import i18n from '@/i18n';
import CompanyBill from './CompanyBill';
import GasStationBill from './GasStationBill';
import QiaoBill from './QiaoBill';
import Overview from './Overview';
import Invoice from './Invoice'; //$IMPORT$

export default () => [
  {
    resourceName: i18n.t('oilcost-index-1992f2b83c87b53d0-1'),
    routerUrl: '/oilcost',
    resourceIcon: '',
    type: '0',
    buttons: [],
    children: [
      Overview(),
      CompanyBill(),
      GasStationBill(),
      QiaoBill(),
      Invoice(), //$MORE$
    ],
  },
];
